import React, { useEffect, useState } from "react";
import Loader from "../../../components/Loader/Loader";
import { getSurveyAnalytics } from "../../../services/SurveyService";

const SurveyAnalyticsTab = ({ survey }) => {
  const [questions, setQuestions] = useState([]);
  const [totalResponses, setTotalResponses] = useState(0);
  const [isLoader, setIsLoader] = useState(true);

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        setIsLoader(true);
        const response = await getSurveyAnalytics(survey.id);
        if (response.status === 200) {
          const payload = response.data.data;
          setQuestions(payload?.questions || []);
          setTotalResponses(payload?.total_responses || 0);
        }
      } catch (error) {
        console.error("API Error:", error.response);
      } finally {
        setIsLoader(false);
      }
    };
    fetchAnalytics();
  }, [survey.id]);

  if (isLoader) {
    return (
      <div className="card survey-panel">
        <div className="survey-panel-body">
          <Loader />
        </div>
      </div>
    );
  }

  return (
    <div className="survey-analytics">
      <div className="survey-analytics-header">
        <div>
          <div className="survey-panel-section-title">Answer distribution</div>
          <div className="survey-analytics-subtitle">
            Tallied across {totalResponses} responses·
          </div>
        </div>
        <span className="survey-mode-chip">{totalResponses} responses</span>
      </div>

      {questions.length === 0 ? (
        <div className="card survey-panel">
          <div className="survey-panel-body">No responses recorded yet.</div>
        </div>
      ) : (
        questions.map((q) => {
          const options = Array.isArray(q.distribution)
            ? q.distribution
            : Object.entries(q.distribution || {}).map(([label, count]) => ({ label, count }));
          const total = options.reduce((sum, opt) => sum + (opt.count || 0), 0);
          return (
            <div
              className="card survey-panel survey-analytics-card"
              key={q.question_id}>
              <div className="survey-panel-body">
                <div className="survey-analytics-question-row">
                  <div className="survey-analytics-question">{q.question}</div>
                  <span className="survey-mode-chip">
                    {q.answered} answered
                  </span>
                </div>
                {options.length === 0 ? (
                  <p className="survey-panel-hint">
                    Open-ended question — no distribution to chart.
                  </p>
                ) : (
                  options.map((opt, index) => {
                    const pct =
                      total > 0 ? Math.round((opt.count / total) * 100) : 0;
                    return (
                      <div className="survey-answer-bar-row" key={`${opt.label}-${index}`}>
                        <div className="survey-answer-bar-label">{opt.label}</div>
                        <div className="survey-answer-bar-track">
                          <div
                            className="survey-answer-bar-fill"
                            style={{ width: `${pct}%` }}
                          ></div>
                        </div>
                        <div className="survey-answer-bar-stats">
                          {opt.count} · {pct}%
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default SurveyAnalyticsTab;
